<template>
    <ns-loader
        ref="ns-loader"
        :to-load="toLoad"
        :fetch-timer="null"
        @dataFetched="onDataFetched"
    >
        <div slot="loader" style="display: flex; justify-content: center; align-items: center;">
            <loading-template></loading-template>
        </div>
        <div
            slot="content"
            class="gcmcn-card-gradient"
            v-loading="loadingWhileTakerGroupFetch"
            element-loading-background="rgba(0, 0, 0, 0.8)"
            style="min-height: 300px;"
        >
            <gcmcn-filters
                ref="gcmcn-filters"
                :filter-values="[selectedSortType, searchFilter]"
                @reset-filters="resetFilters"
            >
                <dropdown
                    name="Sort"
                    :multiple="false"
                    :list="$store.getters.sortTypeList"
                    itemName="name"
                    itemValue="value"
                    :itemsSelected="selectedSortType.length > 0 ? [selectedSortType] : []"
                    @on-select-item="selectedSortType = $event"
                ></dropdown>
                <search-filter ref="search" @new-value="searchFilter = $event"></search-filter>
            </gcmcn-filters>
            <div 
                class="configuration-list"
                ref="confList"
                :style="{height: `calc(100vh - ${this.usedHeight}px)`}"
            >
                <template v-if="filterdTakers.length > 0">
                    <taker-configuration
                        v-loading="loadingConfiguration"
                        element-loading-background="rgba(0, 0, 0, 0.5)"
                        v-for="taker in filterdTakers"
                        :ref="taker.uid"
                        :key="taker.uid"
                        :taker="taker"
                        :channel="channel"
                        :configurations="channelConfigurations"
                        @on-load-taker-group="loadingWhileTakerGroupFetch = $event"
                        @create-configuration="onCreateconfiguration"
                        @on-configuration-cancelled="$emit('on-configuration-cancelled')"
                        @trigger-refresh="triggerRefresh"
                    ></taker-configuration>
                </template>
                <div v-else-if="takersWithRight.length > 0" class="list-empty">
                    No taker(s) match this filters.
                </div>
                <div v-else class="list-empty">
                    No taker(s).
                </div>
            </div>
            <subscribe-modal
                ref="subscribeModal"
                @on-configuration-created="onConfigurationCreated"
            ></subscribe-modal>
        </div>
    </ns-loader>
</template>

<script>
import moment from 'moment';
import {mapGetters} from 'vuex';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader';
import TakerConfiguration from './taker-configuration.vue';
import {
    SubscribeModal,
    LoadingTemplate,
    Dropdown,
    SearchFilter,
    GcmcnFilters,
} from 'gcmcn-common';
export default {

    components: {
        TakerConfiguration,
        NsLoader,
        SubscribeModal,
        Dropdown,
        SearchFilter,
        GcmcnFilters,
        LoadingTemplate,
    },

    props: {
        broadcastRight: {
            type: Array,
            required: true,
        },
        channelConfigurations: {
            type: Array,
            required: true,
        },
        channel: {
            required: true,
            type: Object,
        },
        event: {
            required: true,
            type: Object,
        },
        selectedTaker:{
            type: String,
        }
    },

    data (){
        return {
            loadingConfiguration: false,
            selectedSortType: 'asc',
            searchFilter: '',
            toLoad: [
                {
                    name: 'channels',
                    model: 'channels',
                    filters: {
                        archived: false,
                        status__in: 'AVAILABLE,STARTING,RUNNING,PREPARING',
                    }
                },
                {
                    name: 'configurations',
                    model: 'configurations',
                    filters: {
                        cancelled: false,
                        channel__isnull: false
                        // status__in: 'PENDING,RUNNING,CONNECTING,CONNECTED'
                    }
                },
            ],
            channels: [],
            configurations: [],
            loadingWhileTakerGroupFetch: false,
            usedHeight: 0,
        };
    },

    computed: {
        ...mapGetters([
            'windowWidth'
        ]),
        takersWithRight (){
            return this.$store.getters.takers.filter((taker) => {
                return this.broadcastRight.find((br) => br.taker_uid === taker.uid && br.channel_uid === this.channel.uid && br.revoked === false && br.archived === false);
            });
        },
        filterdTakers (){
            let takers = this.takersWithRight.slice();
            if(this.selectedSortType.length > 0){
                takers.sort((a,b) => {
                    return b.name.toLowerCase().localeCompare(a.name.toLowerCase());
                });
                if(this.selectedSortType === 'asc'){
                    takers.reverse();
                }
            }
            if(this.searchFilter.length > 0){
                let searchFilter = this.searchFilter.toLowerCase();
                takers = takers.filter((taker) => taker.name.toLowerCase().includes(searchFilter));
            }
            return takers;
        },
        duration() {
            return this.endDateTimeUtc.diff(this.startDateTimeUtc, 'minutes');
        },
        startDateTimeUtc() {
            if(this.channel.confirmed){
                return moment.utc(this.channel.confirmed_start_date);
            }
            return moment.utc(this.channel.start_date);
        },
        endDateTimeUtc() {
            if(this.channel.confirmed){
                return moment.utc(this.channel.confirmed_end_date);
            }
            return moment.utc(this.channel.end_date);
        },
    },
    watch: {
        windowWidth (){
            this.computeFilterHeight();
        },
    },
    mounted (){
    },

    methods: {
        onCreateconfiguration(taker, takerGroup) {
            this.loadingConfiguration = true;
            this.$refs['ns-loader'].triggerRefresh().then(() => {
                this.loadingConfiguration = false;
                this.$refs.subscribeModal.open(
                    this.channel,
                    this.channels,
                    'channel',
                    this.configurations,
                    this.event.name,
                    taker,
                    takerGroup,
                );
            });
        },
        onDataFetched (res){
            this.$set(this, 'channels', res.channels);
            this.$set(this, 'configurations', res.configurations);
            this.$nextTick(()=>{
                this.computeFilterHeight();
                if(this.selectedTaker !== ''){
                    this.scrollToConf(this.selectedTaker);
                }
            });
        },
        onConfigurationCreated (){
            this.$refs['ns-loader'].triggerRefresh();
            this.$emit('on-configuration-created');
        },
        resetFilters (){
            this.selectedSortType = '';
            this.$refs.search.clear();
        },
        setViewHeight(){
            this.$nextTick(()=>{
                this.computeFilterHeight();
            });
        },
        computeFilterHeight() {
            if(this.$refs['gcmcn-filters']){
                const clientRect = this.$refs['gcmcn-filters'].$el.getBoundingClientRect();
                this.usedHeight = clientRect.top + clientRect.height + 10 + 32; // +10 par ce que l'element contient un margin, et les margin ne sont pas comptés dans la height d'un element
                // 32 -> on enleve la height du wrapper d'alerte de fundation
            }
        },
        scrollToConf(takerUid){
            let item = this.$refs[takerUid][0];
            let element = this.$refs.confList;
            let top = item.$el.offsetTop;
            this.$nextTick(()=>{
                // 104 === filter height
                element.scrollTop = top - 104;
            });
        },
        triggerRefresh(){
            this.$emit('trigger-refresh')
        }
    },
};
</script>

<style lang="scss">
.configuration-list{
    overflow-y: scroll;
    scroll-behavior: smooth;
}
.channel-confirguration{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
    .channel-name{
        font-size: 20px;
    }
    .configuration-buttons{
        width: 80px;

        .el-icon-check{
            font-size: 40px;
        }
    }

}
</style>



// WEBPACK FOOTER //
// src/components/page/Channels/configuration-view.vue